import React, { PureComponent } from 'react'

// local components
import ThirdPartyItem from './ThirdPartyItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const ThirdPartyItemEditable = EditableHOCWrapper(ThirdPartyItem)

class ThirdPartyItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onThirdPartyAccountUpdate(data, afterOnSave)
  }

  render() {
    const {
      thirdPartyAccount = {},
      lastModified = null,
      defaultEditMode = false,
      onCancel,
      onDelete,
    } = this.props

    return (
      <ThirdPartyItemEditable
        dataToEdit={thirdPartyAccount}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    )
  }
}

export default ThirdPartyItemContainer



// WEBPACK FOOTER //
// ./src/components/ThirdParty/ThirdPartyItemContainer.js